"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function insertImage(editor, imageFile) {
    if (typeof imageFile == 'string') {
        insertImageWithSrc(editor, imageFile);
    }
    else {
        var reader = new FileReader();
        reader.onload = function (event) {
            if (!editor.isDisposed()) {
                insertImageWithSrc(editor, event.target.result);
            }
        };
        reader.readAsDataURL(imageFile);
    }
}
exports.default = insertImage;
function insertImageWithSrc(editor, src) {
    editor.addUndoSnapshot(function () {
        var image = editor.getDocument().createElement('img');
        image.src = src;
        image.style.maxWidth = '100%';
        editor.insertNode(image);
    }, "Format" /* Format */);
}
//# sourceMappingURL=insertImage.js.map